/* @flow */
import React, { Component } from 'react';
import { css, names } from 'linaria';

import withBreakpoint from '../withBreakpoint';
import Grid, { GridCell } from './Grid';
import MediaQueries from '../../constants/MediaQueries';

class FeatureBlock extends Component<{
  layout: 'vertical' | 'horizontal',
  horizontalFigurePosition: 'left' | 'right',
  verticalFigurePosition: 'top' | 'bottom',
  figure: any,
  body: any,
  title: string,
  breakpoint: string,
}> {
  static defaultProps = {
    horizontalFigurePosition: 'left',
  };

  renderLayout() {
    let { layout, horizontalFigurePosition, figure, title, body, breakpoint } = this.props;

    // FeatureBlock can never have a horizontal
    // layout on small screens
    if (breakpoint === 'small') {
      layout = 'vertical';
    }

    if (layout === 'vertical') {
      return (
        <Grid vAlign="middle" hAlign="center">
          <GridCell size="size12of12">
            <div>{figure}</div>
          </GridCell>
          <GridCell size="size12of12">
            <div className={Styles.VerticalBody}>
              {title}
              {body}
            </div>
          </GridCell>
        </Grid>
      );
    } else if (layout === 'horizontal') {
      const wrappedFigure = (
        <GridCell size="size6of12">
          <div
            className={names(
              Styles.Figure,
              horizontalFigurePosition === 'left'
                ? Styles.HorizontalFigureLeft
                : Styles.HorizontalFigureRight
            )}>
            {figure}
          </div>
        </GridCell>
      );

      const wrappedBody = (
        <GridCell size="size6of12" style={{ flex: 1 }}>
          <div>
            {title}
            {body}
          </div>
        </GridCell>
      );

      let [child1, child2] =
        horizontalFigurePosition === 'left'
          ? [wrappedFigure, wrappedBody]
          : [wrappedBody, wrappedFigure];
      return (
        <Grid vAlign="middle" hAlign="center">
          {child1}
          {child2}
        </Grid>
      );
    }
    throw new Error(`Unable to render FeatureBlock for layout ${layout}`);
  }

  render() {
    return <div className={Styles.Container}>{this.renderLayout()}</div>;
  }
}

const Styles = {
  Container: css`
    text-align: center;
    margin: 0 auto;
  `,
  VerticalBody: css`
    max-width: 632px;
    margin: 40px auto 0;
  `,
  Figure: css``,
  HorizontalFigureLeft: css`
    padding: 0 20px;
    ${MediaQueries.Large} {
      margin-right: 58px;
      padding: 0;
    }
  `,
  HorizontalFigureRight: css`
    padding: 0 20px;
    ${MediaQueries.Large} {
      margin-left: 58px;
      padding: 0;
    }
  `,
};

export default withBreakpoint(FeatureBlock);



// WEBPACK FOOTER //
// ./src/ui/components/core/FeatureBlock.js